
import { ISerial } from '@/utils/types/model/serial'
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

interface ITableColumn {
  prop: string
  label: string
  sortable?: boolean | string
  formatter?: (row: ISerial) => string
}

const amountWithUnit = (amount: number, unit?: string) => (unit ? `${amount} (${unit})` : `${amount}`)

@Options({
  name: 'SerialList',
  emits: ['detail', 'sort-change'],
})
export default class SerialList extends Vue {
  @Prop({ type: Array, default: () => [] }) serialData!: ISerial[]

  get tableColumns(): ITableColumn[] {
    return [
      { prop: 'code', label: this.$t('serial_code'), sortable: 'custom' },
      { prop: 'itemCode', label: this.$t('item_code') },
      { prop: 'itemName', label: this.$t('item_name') },
      {
        prop: 'currentAmount',
        label: this.$t('current_amount'),
        formatter: (row: ISerial) => amountWithUnit(row.currentAmount, row.unit),
      },
      {
        prop: 'limitAmount',
        label: this.$t('limit_amount'),
        formatter: (row: ISerial) => amountWithUnit(row.limitAmount, row.unit),
      },
      { prop: 'conversionUnit', label: this.$t('conversion_unit') },
    ]
  }

  handleRowClick(row: ISerial) {
    this.$emit('detail', row.code)
  }

  handleSortChange(data: { prop: string; order: string | null }) {
    this.$emit('sort-change', data)
  }
}
